<template>
<div class="content">
  <div class="header">
    <div style="margin-bottom: 10px">
      <el-button type="primary" size="mini" @click="getList()">刷新</el-button>
      <el-button v-if="is_show_sync" type="primary" size="mini" @click="houseLegalToTemp()">同步欠费</el-button>
      <!--    <el-button size="mini" @click="exportExcel(1)">导出房产（所有房产）</el-button>-->
      <!--    <el-button size="mini" @click="exportExcel(2)">导出房产（催缴房产）</el-button>-->
      <!--    <el-button size="mini" @click="importLegalHouseExcel">导入催缴房产</el-button>-->
      <el-button size="mini" @click="saveBatch(true)">保存</el-button>
      <el-button size="mini" v-if="is_show_flow&&use_flow.includes(2)" @click="toFlow(2)">项目经理审批</el-button>
      <el-button size="mini" v-if="is_show_flow&&use_flow.includes(1)" @click="toFlow(1)">分公司职能审批</el-button>
      <!--    <el-button size="mini" icon="el-icon-full-screen" @click="openFullscreen"></el-button>-->
      <el-button type="danger" size="mini" @click="delHouseIds()">批量移除</el-button>
      <el-button type="danger" size="mini" @click="deleteByAll()">全部移除</el-button>
    </div>

    <div style="margin-bottom: 10px">
      <el-select size="mini" placeholder="催缴类型" :clearable="!(default_urge_type>0)" v-model="where2.urge_type">
        <el-option v-if="default_urge_type>0?(default_urge_type===1):true" :value="1" label="自催"></el-option>
        <el-option v-if="default_urge_type>0?(default_urge_type===2):true" :value="2" label="诉讼"></el-option>
        <el-option v-if="default_urge_type>0?(default_urge_type===5):true" :value="5" label="项目自催"></el-option>
        <el-option v-if="default_urge_type>0?(default_urge_type===3):true" :value="3" label="第三方管理"></el-option>
        <el-option v-if="default_urge_type>0?(default_urge_type===4):true" :value="4" label="第三方诉讼"></el-option>
      </el-select>
      <el-select size="mini" placeholder="账龄类型" clearable multiple collapse-tags v-model="where2.age" >
        <el-option v-if="age_type_ids.includes(1)" :value="1" label="当期"></el-option>
        <el-option v-if="age_type_ids.includes(2)" :value="2" label="纯上一年"></el-option>
        <el-option v-if="age_type_ids.includes(3)" :value="3" label="1年以上2年以内"></el-option>
        <el-option v-if="age_type_ids.includes(4)" :value="4" label="2年以上"></el-option>
      </el-select>
      <!--    <el-date-picker-->
      <!--      style="width: 120px"-->
      <!--      v-model="where2.jh_time"-->
      <!--      size="mini"-->
      <!--      type="month"-->
      <!--      format="yyyy-MM"-->
      <!--      value-format="yyyy-MM" placeholder="计划催费月份">-->
      <!--    </el-date-picker>-->
      <el-date-picker
        style="width: 120px"
        v-model="where2.qf_time"
        size="mini"
        type="month"
        format="yyyy-MM"
        value-format="yyyy-MM" placeholder="欠费月份">
      </el-date-picker>
      <el-date-picker
        style="width: 150px"
        v-model="where2.gj_time"
        size="mini"
        type="date"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd" placeholder="跟进日期">
      </el-date-picker>
      <el-date-picker
        style="width: 120px"
        v-model="where2.last_month"
        size="mini"
        type="month"
        format="yyyy-MM"
        value-format="yyyy-MM" placeholder="上次缴费月份">
      </el-date-picker>
      <el-input clearable placeholder="欠费月数" v-model="where2.month_count" style="width: 100px" size="mini"></el-input>
      <el-select size="mini" placeholder="月催费次数" clearable v-model="where2.cur_month_times" style="width: 120px;">
        <el-option :value="0" label="暂未催费"></el-option>
        <el-option :value="1" label="1次催费"></el-option>
        <el-option :value="2" label="2次催费"></el-option>
        <el-option :value="3" label="3次催费"></el-option>
        <el-option :value="4" label="多次催费"></el-option>
      </el-select>
      <el-select size="mini" placeholder="年催费次数" clearable v-model="where2.cur_year_times" style="width: 120px;">
        <el-option :value="0" label="暂未催费"></el-option>
        <el-option :value="1" label="1次催费"></el-option>
        <el-option :value="2" label="2次催费"></el-option>
        <el-option :value="3" label="3次催费"></el-option>
        <el-option :value="4" label="多次催费"></el-option>
      </el-select>
      <el-select size="mini" placeholder="选择房态" clearable v-model="where2.room_status" style="width: 120px;">
        <el-option value="空置" label="空置"></el-option>
        <el-option value="未领" label="未领"></el-option>
        <el-option value="空关" label="空关"></el-option>
        <el-option value="装修" label="装修"></el-option>
        <el-option value="入住" label="入住"></el-option>
        <el-option value="出租" label="出租"></el-option>
        <el-option value="停用" label="停用"></el-option>
      </el-select>
      <el-select size="mini" placeholder="欠费类型" clearable v-model="where2.arrears_level1" style="width: 180px;" @change="changeArrearsLevel1">
        <el-option v-for="(item, index) in arrears_arr" :key="index" :value="item.name" :label="item.name"></el-option>
      </el-select>
      <el-select size="mini" placeholder="欠费类型-原因" clearable v-model="where2.arrears_level2" style="width: 180px;">
        <el-option v-for="(item, index) in arrears_arr_children" :key="index" :value="item.name" :label="item.name"></el-option>
      </el-select>
      <el-input clearable placeholder="输入房产" v-model="where2.house_name" style="width: 200px" size="mini"></el-input>
    </div>
  </div>
  <AgeTip
    :project_id="reginWhere.project_name"
    :project_ids="reginWhere.project_ids"
    :ages="where2.age"
  >
    <span slot="start">
      欠费房产数：{{pageData.total}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span>
    <span slot="default">

    </span>
  </AgeTip>
  <div class="header-tip" v-if="selectCount>0">
    <span v-if="selectCount>0">选择房产数：{{selectCount}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <span v-if="selectDebtAmount>0">欠费金额：{{formatMoney(selectDebtAmount,2)}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <span v-if="selectLawsuitAmount>0">诉讼金额：{{formatMoney(selectLawsuitAmount,2)}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <span v-if="selectCount1>0">自催户数：{{selectCount1}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <span v-if="selectCount2>0">诉讼户数：{{selectCount2}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <span v-if="selectCount5>0">项目自催户数：{{selectCount5}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <span v-if="selectCount3>0">第三方管理户数：{{selectCount3}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <span v-if="selectCount4>0">第三方诉讼户数：{{selectCount4}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <span v-if="selectCount6>0">可发起流程户数：{{selectCount6}}</span>
  </div>
  <div class="body">
    <div>
      <div class="table-wrap">
        <VeTable
          v-loading="loading"
          ref="tableRef"
          rowKeyFieldName="id"
          :max-height="ve_table_max_height"
          :fixed-header="true"
          :virtual-scroll-option="virtualScrollOption"
          :edit-option="editOption"
         :cell-autofill-option="cellAutofillOption"
          :cellSelectionOption="cellSelectionOption"
         :rowStyleOption="rowStyleOption"
          :checkbox-option="checkboxOption"
          :cell-style-option="cellStyleOption"
          style="width: 100%;"
         :scroll-width="0"
         :border-y="true"
          :contextmenu-body-option="contextmenuBodyOption"
          :contextmenu-header-option="contextmenuHeaderOption"
          :column-width-resize-option="columnWidthResizeOption"
          :clipboard-option="clipboardOption"
          :columns="columns"
          :columnHiddenOption="columnHiddenOption"
          :table-data="tableData" />
      </div>
      <div class="pagination-wrap">
        <el-select v-model="pageData.pageSize" size="mini" style="width: 80px" placeholder="每页条数" @change="pageChange(1)">
          <el-option label="10" value="10"></el-option>
          <el-option label="20" value="20"></el-option>
          <el-option label="30" value="30"></el-option>
          <el-option label="50" value="50"></el-option>
          <el-option label="100" value="100"></el-option>
          <el-option label="200" value="200"></el-option>
          <el-option label="500" value="500"></el-option>
          <el-option label="1000" value="1000"></el-option>
          <el-option label="5000" value="5000"></el-option>
          <el-option label="10000" value="10000"></el-option>
        </el-select>
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                       :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                       @current-change="pageChange"></el-pagination>
      </div>
    </div>
    <el-dialog title="修改催缴类型" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="onClose" width="600px">

      <div class="view-file-win">
        <el-descriptions class="margin-top" :column="1" size="mini" border>
          <el-descriptions-item label="房产信息">{{ from_data['房产信息'] }}</el-descriptions-item>
          <el-descriptions-item label="区域">{{ from_data['区域'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费金额">{{ from_data['欠费金额'] }}</el-descriptions-item>
          <el-descriptions-item label="催缴类型">
            <el-select placeholder="催缴类型" v-model="from_data['催缴类型']">
              <el-option value="自催" label="自催"></el-option>
              <el-option value="诉讼" label="诉讼"></el-option>
              <el-option value="第三方" label="第三方"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="计划催缴月份">
            <el-date-picker
              style="width: 150px"
              v-model="from_data['计划催缴月份']"
              size="mini"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="账龄类型">{{ from_data['账龄类型'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费类型">{{ from_data['欠费类型'] }}</el-descriptions-item>
<!--          <el-descriptions-item label="欠费原因">{{ from_data['欠费原因'] }}</el-descriptions-item>-->
          <el-descriptions-item label="业主诉求">{{ from_data['业主诉求'] }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <template slot="footer">
        <div>
          <el-button @click="onClose">关 闭</el-button>
          <el-button @click="editTypeSubmit">修 改</el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog title="最后一次缴费明细" :visible.sync="dialogVisible_2" :close-on-click-modal="false" width="600px">

      <div class="view-file-win">
        <el-descriptions class="margin-top" :column="1" size="mini" border>
          <el-descriptions-item label="房产信息">{{ house_bill_order_2['房产信息'] }}</el-descriptions-item>
          <el-descriptions-item label="区域">{{ house_bill_order_2['区域'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费金额">{{ house_bill_order_2['欠费金额'] }}</el-descriptions-item>
          <el-descriptions-item label="账龄类型">{{ house_bill_order_2['账龄类型'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费类型">{{ house_bill_order_2['欠费类型'] }}</el-descriptions-item>
<!--          <el-descriptions-item label="欠费原因">{{ house_bill_order_2['欠费原因'] }}</el-descriptions-item>-->
          <el-descriptions-item label="业主诉求">{{ house_bill_order_2['业主诉求'] }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <template slot="footer">
        <div>
          <el-button @click="dialogVisible_2=false">关 闭</el-button>
        </div>
      </template>
    </el-dialog>

  </div>
  <ViewFile ref="ViewFile" />
  <ViewFlow ref="viewFlowRef" />
  <ConfirmDialog ref="ConfirmDialogRef" />
  <LegalHouseMoneyList ref="legalHouseMoneyListRef" />
</div>
</template>

<script>
import Http from "../../common/Http";
import moment from "moment/moment";
import ViewFile from "../../../Common/ViewFile";
import Track from "../../../../../assets/js/trackHttp";
import {CommonHelp} from "../../common/CommonHelp";
import ViewFlow from "../../../Common/ViewFlow";
import ButlerHttp from "../../common/ButlerHttp";
import ConfirmDialog from "../common/ConfirmDialog";
import AgeTip from "../common/AgeTip";
import LegalHouseMoneyList from "../LegalHouseMoneyList";

let editCell = [];
export default {
  name: "LegalHousePlanTempProjectExcel",
  components: {LegalHouseMoneyList, AgeTip, ConfirmDialog, ViewFlow, ViewFile},
  inject:['where','reginWhere'],
  props: {
    age_type_ids:{
      type:Array,
      default(){
        return []
      }
    },
    is_show_flow:{
      type:Boolean,
      default(){
        return false
      }
    },
    use_flow:{
      type:Array,
      default(){
        return [];
      }
    },
    is_show_sync:{
      type:Boolean,
      default:false
    },
    default_urge_type:{
      type:Number|String,
      default:""
    }
  },
  data(){
    const self = this;
    return{
      where2:{
        urge_type:"",
        age:this.age_type_ids,
        cur_month_times:"",
        cur_year_times:"",
        type:"",
        qf_time:moment().format("YYYY-MM"),
        jh_time:"",
        last_month:"",
        house_name:"",
        room_status:"",
        arrears_level1:'',
        arrears_level2:'',
        order_by:"",
        gj_time:"",
        month_count:"",
      },
      loading:false,
      pageData:{
        list: [],
        total: 0,
        pageSize: 20,
        page: 1,
      },
      from_data:{},
      dialogVisible:false,
      dialogVisible_2:false,
      house_bill_order_2:{},
      multipleSelection:[],
      ve_table_max_height:'50vh',
      columns:[
        {
          field: "",
          key: "a",
          // type=checkbox
          type: "checkbox",
          title: "",
          width: 50,
          align: "center",
        },
        { field: "house_name", key: "house_name", title: "房产信息", align: "center" ,width:320,fixed: "left" ,ellipsis: {showTitle: true}},
        { field: "area_name", key: "area_name", title: "区域", align: "center" ,width:90 },
        { field: "owner_name", key: "owner_name", title: "业主姓名", align: "center" ,width:220 },
        { field: "owner_phone", key: "owner_phone", title: "业主电话", align: "center" ,width:220 },
        { field: "bank_account", key: "bank_account", title: "银行划扣", align: "center" ,width:90 },
        { field: "room_status", key: "room_status", title: "房态", align: "center" ,width:90 },
        { field: "debt_start_month", key: "debt_start_month", title: "欠费起始月份", align: "center" ,width:120 },
        { field: "debt_month", key: "debt_month", title: "欠费月数", align: "center" ,width:100 },
        { field: "debt_amount", key: "debt_amount", title: "欠费金额", align: "center" ,width:100 },
        { field: "plan_urge_month", key: "plan_urge_month", title: "计划催缴月份", align: "center",width:150,edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <el-date-picker
                disabled
                size="mini"
                style="width: 100%;"
                value={row["plan_urge_month"]}
                on-input={(val) => {
                  row["plan_urge_month"] = val;
                  this.cellDataChange(row, column, val);
                }}
                type="month"
                format="yyyy-MM"
                value-format="yyyy-MM" placeholder="选择计划催缴月份"
                />
            );
          },
        },
        { field: "urge_type", key: "urge_type", title: "催缴类型", align: "center",width:120,edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <el-select
                size="mini"
                style="width: 100%;"
                disabled
                value={row["urge_type"]}
                on-change={(val) => {
                  row["urge_type"] = val;
                  if(val === "诉讼" || val === "第三方诉讼"){
                    row["lawsuit_amount"] = row["debt_amount"];
                  }else {
                    row["lawsuit_amount"] = 0;
                  }
                  this.cellDataChange(row, column, val);
                }}
                placeholder="请选择催缴类型"
              >
                <el-option value="" label="--"></el-option>
                <el-option value="自催" label="自催"></el-option>
              </el-select>
            );
          },
        },
        { field: "lawsuit_amount", key: "lawsuit_amount", title: "诉讼金额", align: "center" ,width:200 ,edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row["lawsuit_amount"];
          },
        },
        { field: "third_party_company", key: "third_party_company", title: "第三方合作单位", align: "center",width:150,edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <el-select
                size="mini"
                style="width: 100%;"
                disabled
                value={row["third_party_company"]}
                on-input={(val) => {
                  row["third_party_company"] = val;
                }}
                on-change={(val) => {
                  this.cellDataChange(row, column, val);
                }}
                placeholder="请选择"
              >
                {
                  this.company_list.map((item) => {
                    return <el-option value={item.name} label={item.name}></el-option>
                  })
                }
              </el-select>
            );
          },
        },
        { field: "debt_type", key: "debt_type", title: "欠费类型", align: "center",width:200,edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            if(row.debt_type){
              return row.debt_reason?`${row.debt_type} : ${row.debt_reason}`:row.debt_type
            }else {
              return row.debt_type
            }
          },
        },
        { field: "debt_reason", key: "debt_reason", title: "欠费原因", align: "center",width:150,edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            if(row["debt_type"] == "其它(手写)"){
              return row["debt_reason"];
            }else {
              return ''
            }
          },
        },
        { field: "owner_demand", key: "owner_demand", title: "业主诉求", align: "center",width:150,edit: false,ellipsis: {showTitle: true}},
        { field: "solution", key: "solution", title: "解决措施", align: "center",width:180,edit: false,ellipsis: {showTitle: true}},
        { field: "debt_age_type", key: "debt_age_type", title: "账龄类型", align: "center" ,width:180},
        { field: "payment_type", key: "payment_type", title: "缴费类型", align: "center" ,width:90 },
        { field: "payed_last_way", key: "payed_last_way", title: "上次缴费方式", align: "center" ,width:120 },
        { field: "last_payment_time", key: "last_payment_time", title: "上次缴费日期", align: "center" ,width:120 },
        { field: "one_gj_time", key: "one_gj_time", title: "第一次跟进时间", align: "center" ,width:170 },
        { field: "two_gj_time", key: "two_gj_time", title: "第二次跟进时间", align: "center" ,width:170 },
        { field: "third_urge_time", key: "third_urge_time", title: "第三次跟进时间", align: "center" ,width:170 },
        { field: "cur_month_times", key: "cur_month_times", title: "月催缴次数", align: "center" ,width:100 },
        { field: "cur_year_times", key: "cur_year_times", title: "年催缴次数", align: "center" ,width:100 },
        { field: "house_id", key: "house_id", title: "房产ID", align: "center" ,width:100 },
      ],
      columnHiddenOption: {
        defaultHiddenColumnKeys: ["lawsuit_amount", "third_party_company"],//
      },
      tableData: [],
      submitData: [],
      virtualScrollOption:{
        enabled: true,
      },
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (editCell.includes(column.field)) {
            return "table-header-cell-class";
          }
        },
      },
      editOption:{
        // cellValueChange: ({ row, column }) => {
        //   console.log("cellValueChange row::", row);
        //   console.log("cellValueChange column::", column);
        // },
        afterCellValueChange: ({ row, column, changeValue  }) => {
          this.cellDataChange(row, column, changeValue);
        }
      },
      cellAutofillOption: {
        directionX: false,
        directionY: true,
        beforeAutofill({sourceSelectionRangeIndexes, targetSelectionRangeIndexes,sourceSelectionData, targetSelectionData}){
          let sourceSelection=sourceSelectionData[0]
          let keys = Object.keys(sourceSelection);
          if(keys.length>0){
            if(editCell.includes(keys[1])){
              targetSelectionData.forEach(val => {
                let filed=Object.keys(val)[1];
                self.cellDataChangeValue(val.id,filed,sourceSelection[filed]);
              });
              return true;
            }
          }

          // console.log("keys::", keys);
          return false;
        }
      },
      rowStyleOption: {
        clickHighlight: false,
        hoverHighlight: false,
      },
      cellSelectionOption: {
        // disble cell selection
        enable: true,

      },
      checkboxOption: {
        // 行选择改变事件
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          // console.log(row, isSelected, selectedRowKeys);
          // this.multipleSelection = selectedRowKeys;
          this.multipleSelection = this.tableData.filter(item => (selectedRowKeys||[]).includes(item.id));
        },
        // 全选改变事件
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          // console.log(isSelected, selectedRowKeys);
          // this.multipleSelection = selectedRowKeys;
          this.multipleSelection = this.tableData.filter(item => (selectedRowKeys||[]).includes(item.id));
        },
      },
      // 表头右击菜单选项
      contextmenuHeaderOption: {
        /*
        before contextmenu show.
        In this function,You can change the `contextmenu` options
        */
        beforeShow: ({
                       isWholeColSelection,
                       selectionRangeKeys,
                       selectionRangeIndexes,
                     }) => {
        },
        // after menu click
        afterMenuClick: ({ type, selectionRangeKeys, selectionRangeIndexes }) => {
          let startColKey = selectionRangeKeys.startColKey;
          switch (type) {
            case "EMPTY_COLUMN":
              console.log("清空列");
              break;
            case "ORDER_ASC":
              console.log("升序",startColKey);
              self.where2.order_by=startColKey+" asc";
              break;
            case "ORDER_DESC":
              console.log("降序",startColKey);
              self.where2.order_by=startColKey+" desc";
              break;
            case "LEFT_FIXED_COLUMN_TO":
              console.log("左列冻结至该列");
              break;
            case "CANCEL_LEFT_FIXED_COLUMN_TO":
              console.log("取消左列冻结至该列");
              break;
            case "RIGHT_FIXED_COLUMN_TO":
              console.log("右列冻结至该列");
              break;
            case "CANCEL_RIGHT_FIXED_COLUMN_TO":
              console.log("取消右列冻结至该列");
              break;
          }
        },

        // contextmenus
        contextmenus: [
          // {
          //   label: "剪切",
          //   type: "CUT",
          // },
          // {
          //   label: "复制",
          //   type: "COPY",
          // },
          // {
          //   label: "分割线",
          //   type: "SEPARATOR",
          // },
          {
            label: "排序",
            type: "ORDER",
            children: [
              {
                label: "升序",
                type: "ORDER_ASC",
              },
              {
                label: "降序",
                type: "ORDER_DESC",
              },
            ],
          },
          // {
          //   label: "分割线",
          //   type: "SEPARATOR",
          // },
          // {
          //   label: "清空列",
          //   type: "EMPTY_COLUMN",
          // },
          {
            label: "分割线",
            type: "SEPARATOR",
          },
          {
            label: "左列冻结至该列",
            type: "LEFT_FIXED_COLUMN_TO",
          },
          {
            label: "取消左列冻结至该列",
            type: "CANCEL_LEFT_FIXED_COLUMN_TO",
          },
          {
            label: "右列冻结至该列",
            type: "RIGHT_FIXED_COLUMN_TO",
          },
          {
            label: "取消右列冻结至该列",
            type: "CANCEL_RIGHT_FIXED_COLUMN_TO",
          },
        ],
      },

      // 内容右击菜单选项
      contextmenuBodyOption: {
        /*
        before contextmenu show.
        In this function,You can change the `contextmenu` options
        */
        beforeShow: ({
                       isWholeRowSelection,
                       selectionRangeKeys,
                       selectionRangeIndexes,
                     }) => {
          console.log("---contextmenu body beforeShow--");
          console.log("isWholeRowSelection::", isWholeRowSelection);
          console.log("selectionRangeKeys::", selectionRangeKeys);
          console.log("selectionRangeIndexes::", selectionRangeIndexes);
        },
        // after menu click
        afterMenuClick: ({ type, selectionRangeKeys, selectionRangeIndexes }) => {
          console.log("---contextmenu body afterMenuClick--");
          console.log("type::", type);
          console.log("selectionRangeKeys::", selectionRangeKeys);
          console.log("selectionRangeIndexes::", selectionRangeIndexes);
        },

        // contextmenus
        contextmenus: [
          // {
          //   label: "剪切",
          //   type: "CUT",
          // },
          {
            label: "复制",
            type: "COPY",
          },
          {
            label: "分割线",
            type: "SEPARATOR",
          },
          // {
          //   label: "在上方插入行",
          //   type: "INSERT_ROW_ABOVE",
          // },
          // {
          //   label: "在下方插入行",
          //   type: "INSERT_ROW_BELOW",
          // },
          {
            label: "分割线",
            type: "SEPARATOR",
          },
          // {
          //   label: "删除行",
          //   type: "REMOVE_ROW",
          // },
          // {
          //   label: "清空行",
          //   type: "EMPTY_ROW",
          // },
          // {
          //   label: "清空单元格",
          //   type: "EMPTY_CELL",
          // },
        ],
      },
      columnWidthResizeOption: {
        // default false
        enable: true,
        // column resize min width
        minWidth: 30,
      },
      clipboardOption: {
        copy: true,
        paste: true,
        cut: false,
        delete: true,
        beforePaste: ({ data, selectionRangeIndexes, selectionRangeKeys }) => {
          if(!editCell.includes(selectionRangeKeys.startColKey)){
            return false;
          }
          let tableData=JSON.parse(JSON.stringify(self.tableData));
          let newData=tableData.splice(selectionRangeIndexes.startRowIndex, selectionRangeIndexes.endRowIndex+1);
          newData.forEach((item,index) => {
            self.cellDataChangeValue(item.id, selectionRangeKeys.startColKey, ((data[index]||{})[selectionRangeKeys.startColKey]||''));
          })
          return true;
        },
      },
      company_list:[],
      arrears_arr:[],
      arrears_arr_children:[],
    }
  },
  mounted() {
    const that=this;
    this.getAllOfIdAndName()
    that.where2.urge_type=that.default_urge_type;
    this.pageChange(1);
    this.getArrearsArr();
    const elem = that.$refs.tableRef.$el;
    elem.addEventListener('fullscreenchange', function (event) {
      console.log('fullscreenchange',event);
      if (elem.requestFullscreen || elem.mozRequestFullScreen || elem.webkitRequestFullscreen || elem.msRequestFullscreen) {
        that.ve_table_max_height = '100vh';
      } else {
        that.ve_table_max_height = '50vh';
      }
    });
    setTimeout(() => {that.initTable();},500);
  },
  watch:{
    "default_urge_type":function (n,o) {
      this.where2.urge_type=n;
    },
    "reginWhere.type_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_region":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.area_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.age":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.type":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.urge_type":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.qf_time":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.cur_month_times":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.cur_year_times":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.room_status":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.arrears_level1":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.arrears_level2":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.jh_time":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.last_month":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.house_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.order_by":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.gj_time":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.month_count":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    age_type_ids:{
      deep:true,
      immediate:true,
      handler(n,o){
        this.initTable();
      }
    }
  },
  computed:{
    ids(){
      return this.multipleSelection.map(ret=>ret.id);
    },
    selectCount(){
      return this.multipleSelection.length
    },
    selectCount1(){
      return this.multipleSelection.filter(ret=>ret.urge_type==='自催').length
    },
    selectCount2(){
      return this.multipleSelection.filter(ret=>ret.urge_type==='诉讼').length
    },
    selectCount3(){
      return this.multipleSelection.filter(ret=>ret.urge_type==='第三方管理').length
    },
    selectCount4(){
      return this.multipleSelection.filter(ret=>ret.urge_type==='第三方诉讼').length
    },
    selectCount5(){
      return this.multipleSelection.filter(ret=>ret.urge_type==='项目自催').length
    },
    selectCount6(){
      return this.multipleSelection.filter(ret=>ret.urge_type&&ret.plan_urge_month).length
    },
    selectDebtAmount(){
      return this.multipleSelection.reduce((acc,cur)=>{
        return acc+((cur.debt_amount||0)*1)
      },0)
    },
    selectLawsuitAmount(){
      return this.multipleSelection.reduce((acc,cur)=>{
        return acc+((cur.lawsuit_amount||0)*1)
      },0)
    },
  },
  methods:{
    getList(){
      const that = this;
      that.loading = true;
      let where = {
        ...that.where2,

        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id
      }
      where.age=where.age.join(',')

      ButlerHttp.post("HouseUrgeTempLog/index",{
        ...where,
        age_type_ids:that.age_type_ids.join(','),
        page: that.pageData.page,
        pageSize: that.pageData.pageSize
      }, res => {
        if (res.code) {
          res.data.list.map(ret => {

            // ret.is_invoice=ret.is_invoice === 1;
            // ret.is_paid=ret.is_paid === 1;
            return ret;
          })
          that.pageData = res.data
          that.tableData = res.data.list
        }
        that.loading = false;
      })
    },
    pageChange(i) {
      const that=this;
      that.pageData.page = i;
      CommonHelp.debounce(()=>{
        if(that.submitData.length>0){
          that.saveBatch(false)
        }
        that.getList()
      },500,that);

    },
    getArrearsArr(){
      const that=this;
      ButlerHttp.get("Legal/getArrearsArr",{},ret=>{
        if(ret.code){
          that.arrears_arr=ret.data;
        }
      })
    },
    houseLegalToTemp(){
      const that=this;
      if(!that.reginWhere.project_name){
        that.$message.error('请选择项目！');
        return false
      }
      let where = {
        ...that.where2,
        age_type_ids:that.age_type_ids.join(','),
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id
      }
      that.$refs.ConfirmDialogRef.show({
        title: '同步房产欠费提示',
        content: `
        <div style="font-size: 18px;line-height: 1.5;color:#000000;width: 100%;">
<p>1.系统会自动把&ldquo;账龄类型&rdquo;为当期和纯上1年的欠费设置为【<span style="color:#e74c3c"><strong><u>自催</u></strong></span>】。</p>
<p>2.系统会自动把 <u>当期欠费且欠费起始月份为当月</u> 的【欠费类型】设置为【正常缴费】。</p>
<p>3.系统已经做过 <u>诉讼、第三方诉讼和第三方管理</u> 的欠费房产，系统会保留之前的计划欠费月份。</p>
<p>4.原 <u>诉讼和第三方诉讼</u> 的房产，系统会自动更新为最新欠费金额。</p>
<p>5.原 <u>第三方管理和第三方诉讼</u> 的房产，系统会保留【第三方合作单位】。</p>
<p>6.当月年诉讼计划的房产，系统会自动把年计划当月诉讼房产叠加进当月的计划里，金额取最新的欠费金额。</p>
<p>7.计划房产类型只有住宅、商铺和写字楼。</p>
<p>8.同步计划欠费的房产是：<u>非划扣</u>、<u>划扣但不是当前欠费</u>和<u>划扣且当前欠费月数大于1个月</u>的房产。</p>
</div>
        `,
        delayTimer:3,
        confirmFn: () => {
          that.loading = true;
          ButlerHttp.post("LegalHouse/lossHouseLegalToTemp",{
            ...where,
          }, res => {
            that.loading = false;
            if (res.code) {
              that.pageChange(1);
              that.$message.success("同步成功")
              that.$emit("onAdd",{})
            }else {
              that.$message.error(res.msg);
            }
          });
        },
        cancelFn: () => {
          that.$message.error("取消操作");
        }
      });

    },
    exportExcel(type=1) {
      const that = this;
      console.log(that.reginWhere.project_name)
      if(!that.reginWhere.project_name){
        that.$message.error("请选择项目")
        return false
      }
      const loading=that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let where = {
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name
      }
      if(type===2){
        where={
          ...where,
          ...that.where2,
          area_id:that.reginWhere.area_id
        }
      }
      // type===1?"admin/Legal/getLegalHouseExcel2":"admin/Legal/getLegalHouseExcel"
      ButlerHttp.post(type===1?"Legal/getLegalHouseExcel2":"Legal/getLegalHouseExcel", {
        ...where
      }, res => {
        loading.close();
        if (res.code) {
          that.$refs.ViewFile.show({
            width: '90vw',
            height: '80vh',
            title: "文件预览",
            src: __HTTP__.defaults.baseURL + res.data,
            download() {
              window.open(__HTTP__.defaults.baseURL + res.data);
            }
          });
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    importLegalHouseExcel(){
      const that=this;
      Http.uploadFile(file=>{
        const loading=that.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        ButlerHttp.post("Legal/importLegalHouseToFlow", {
          file: file
        }, res => {
          loading.close();
          if (res.code) {
            let timeStr = new Date().getTime();
            ERP.navigateTo(`/flow/FlowView?sheet_id=140&master_id=114&timeValue=${timeStr}&batch_number=${res.data}`);
            // that.pageChange(1);
          } else {
            that.$message.error(res.msg);
          }
        });
      })
    },
    toFlow(type){
      const that=this;
      if(!that.reginWhere.project_name){
        that.$message.error("请选择项目")
        return false
      }
      let where = {
        ...that.where2,
        age_type_ids:that.age_type_ids.join(','),
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id
      }
      if(that.ids.length){
        where.ids=that.ids.join(',')
      }
      that.loading = true;
      ButlerHttp.post("HouseUrgeTempLog/toFlow",{
        ...where
      }, res => {
        that.loading = false;
        if (res.code===1) {
          let timeStr=(new Date()).getTime()
          if(type===1){
            // 分公司职能
            let urge_type_obj={
              1:'来源于【自催】的调整',
              2:'来源于【诉讼】的调整',
              5:'来源于【项目自催】的调整',
              3:'来源于【第三方管理】的调整',
              4:'来源于【第三方诉讼】的调整'
            }
            let urge_type=urge_type_obj[that.where2.urge_type]||"来源于【未知】的调整"
            ERP.navigateTo(`/flow/FlowView?sheet_id=249&master_id=180&timeValue=${timeStr}&batch_number=${res.data}&urge_type=${urge_type}`)
          }else if(type===2){
            // 项目经理
            ERP.navigateTo(`/flow/FlowView?sheet_id=179&master_id=145&timeValue=${timeStr}&batch_number=${res.data}`)
          }else{

          }
        }else {
          that.$message.error(res.msg);
        }
      })
    },
    editType(item){
      const that=this;
      that.from_data=item;
      that.dialogVisible=true;
    },
    onClose(){
      this.dialogVisible=false;
      this.from_data={}
    },
    editTypeSubmit(){
      const that=this;
      let urge_type_obj={
        '自催':1,
        '诉讼':2,
        '第三方':3
      }
      ButlerHttp.post("Legal/updateLegalHouseType", {
        id: that.from_data.id,
        ch_md5: that.from_data.ch_md5,
        urge_type: urge_type_obj[that.from_data['催缴类型']],
        year_month: that.from_data['计划催缴月份']
      }, res => {
        if (res.code) {
          that.onClose();
          that.$message.success("操作成功");
          that.pageChange(1);
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    getHouseBill(item){
      const that=this;
      that.$refs.legalHouseMoneyListRef.show({
        project_id:item.project_id,
        house_id:item.house_id,
      })
    },
    getLastHouseBill(item){
      const that=this;
      ButlerHttp.post("Legal/getLastHouseBill", {
        projectId: item.project_id,
        houseId: item.house_id,
        last_time: item.last_payment_time
      }, res => {
        if (res.code) {
          that.dialogVisible_2 = true;
          that.house_bill_order_2 = res.data;
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    delHouse(item){
      const that=this;
      that.loading = true;
      ButlerHttp.post("HouseUrgeTempLog/delete",{
        id:item.id
      }, res => {
        that.loading = false;
        if (res.code) {
          that.$message.success("删除成功")
          that.getList();
          that.$emit("onAdd")
        }else {
          that.$message.error(res.msg);
        }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    delHouseIds(){
      const that=this;
      if(!that.reginWhere.project_name){
        that.$message.error('请选择项目！');
        return false
      }
      if(!that.ids.length){
        that.$message.error('请勾选房产！');
        return false
      }
      that.loading = true;
      ButlerHttp.post("HouseUrgeTempLog/deleteBatch",{
        ids:that.ids.join(','),
        project_id:that.reginWhere.project_name
      }, res => {
        that.loading = false;
        if (res.code) {
          that.$message.success("删除成功")
          that.getList();
          that.$emit("onAdd")
        }else {
          that.$message.error(res.msg);
        }
      })
    },
    deleteByAll(){
      const that=this;
      if(!that.reginWhere.project_name){
        that.$message.error("请选择项目")
        return false
      }
      let where = {
        ...that.where2,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id
      }
      that.loading = true;
      ButlerHttp.post("HouseUrgeTempLog/deleteByAll",where, res => {
        that.loading = false;
        if (res.code) {
          that.$message.success("删除成功")
          that.pageChange(1);
          that.$emit("onAdd")
        }else {
          that.$message.error(res.msg);
        }
      })
    },
    openFlow(item){
      const that = this;
      if(!item.task_id){
        that.$message.error('没有审批流程')
        return;
      }
      that.$refs.viewFlowRef.show({task_id:item.task_id})
    },
    openFullscreen() {
      const that = this;
      const elem = that.$refs.tableRef.$el;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) { /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) { /* IE/Edge */
        elem.msRequestFullscreen();
      }
    },
    getAllOfIdAndName(){
      const that=this;
      ButlerHttp.get("ProjectCollectionThridCompany/getAllOfIdAndName",{}, res => {
        if (res.code) {
          that.company_list=res.data
        }
      });
    },
    saveBatch(is_load=true){
      const that=this;
      if(!that.reginWhere.project_name) {
        that.$message.error('请选择项目！');
        return false
      }
      that.loading = true;
      ButlerHttp.post("HouseUrgeTempLog/saveBatch",{
        list:JSON.stringify(that.submitData),
        project_id:that.reginWhere.project_name
      }, res => {
        that.loading = false;
        if (res.code) {
          that.submitData=[];
          that.$message.success("保存成功")
          is_load&&that.getList();
          is_load&&that.$emit("onAdd")
        }else {
          that.$message.error(res.msg);
        }
      })
    },
    cellDataChange(row, column, cellValue) {
      const that = this;
      const { submitData } = this;

      row[column.field] = cellValue;
      let currentCellIndex = submitData.findIndex((x) => x.id === row["id"]);
      if (currentCellIndex === -1) {
        that.submitData.push(row);
      }else {
        that.submitData[currentCellIndex] = row;
      }
    },
    cellDataChangeValue(id, name, value) {
      const that = this;
      const { submitData,tableData } = this;
      let row = tableData.find((x) => x.id == id);
      if (!row) {
        that.$message.error("数据异常");
        return;
      }
      row[name] = value;
      let currentCellIndex = submitData.findIndex((x) => x.id == id);
      if (currentCellIndex === -1) {
        that.submitData.push(row);
      }else {
        that.submitData[currentCellIndex] = row;
      }
    },
    cellDataChangeRow(id) {
      const that = this;
      const { submitData,tableData } = this;
      let row = tableData.find((x) => x.id == id);
      let currentCellIndex = submitData.findIndex((x) => x.id == id);
      if (currentCellIndex!== -1) {
        that.submitData.push(row);
      }else {
        that.submitData[currentCellIndex] = row;
      }
    },
    roundValue(num, n=2){
      return Math.round(num * Math.pow(10, n)) / Math.pow(10, n);
    },
    getArrearsSelected(list=[],id,default_value=''){
      let selectedIndex=list.findIndex((x) => x.id == id);
      if(selectedIndex!==-1){
        return {
          index:selectedIndex,
          name:(list[selectedIndex]||{}).name||default_value
        }
      }else {
        return {
          index:selectedIndex,
          name:default_value
        }
      }
    },
    initTable(){
      const that=this;
      if(!that.$refs.tableRef){
        return;
      }
      console.log(that.$refs.tableRef,that.age_type_ids);
      if(that.age_type_ids.includes(1)||that.age_type_ids.includes(2)){
        that.$refs.tableRef.hideColumnsByKeys("lawsuit_amount");
        that.$refs.tableRef.hideColumnsByKeys("third_party_company");
      }else {
        that.$refs.tableRef.showColumnsByKeys("lawsuit_amount");
        that.$refs.tableRef.showColumnsByKeys("third_party_company");
      }
    },
    changeArrearsLevel1(name){
      const that=this;
      let arrears_index=that.arrears_arr.findIndex(ret=>ret.name===name)
      if(arrears_index!==-1){
        that.arrears_arr_children=that.arrears_arr[arrears_index].children||[];
        that.where2.arrears_level2='';
      }else {
        that.arrears_arr_children=[];
        that.where2.arrears_level2='';
      }
    },
  }
}



</script>

<style lang="scss" scoped>
@import "../../common";
.content{
  min-height: calc(100vh - 350px);

  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: inline-block;
  }
  .body{
    .table-wrap{
      .table-wrap-table{
        width: 100%;

      }

    }
    .pagination-wrap{
      display: flex;
      justify-content: center;
      margin-top: 10px;
    }
  }

}

/deep/ .el-table th.el-table__cell.is-leaf{
  padding: 0;
  margin: 0;
  .label-column-edit{
    background-color: #f56c6c;
    color: #FFFFFF;
    cursor: pointer;
    padding: 8px 0;
    text-align: center;
  }
}

/deep/ .table-header-cell-class {
  background: orange !important;
  color: #fff !important;
}

/deep/ .ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content tbody.ve-table-body tr.ve-table-body-tr td.ve-table-body-td,
.ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content tbody.ve-table-body tr.ve-table-expand-tr td.ve-table-body-td {
  padding: 0 5px;

  .el-input__inner{
    color: black;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/plan/LegalHousePlanTempProjectExcel.vue